import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Grid } from "@mui/material";
import MyPosts from "../Post/MyPosts";
import MyBookings from "./MyBookings";
import PaymentDetails from "./PaymentDetails";
import RecentActivity from "./RecentActivity";
import Header1 from "../Header/Header1";
import axios from "axios";
import MyRequests from "../Requests/MyRequests";
import AcceptedRequests from "../Requests/AcceptedRequests";
import RequestToUsers from "../Requests/RequestToUsers";
import RequestFromUsers from "../Requests/RequestFromUsers";
import RequestUserPlatform from "../RequestUser/RequestUserPlatform";
import MyPostsPlatform from "../Post/MyPostsPlatform";
import MyRequestsPlatform from "../Requests/MyRequestsPlatform";
import Platform from "./Platform";

const API_URL = process.env.REACT_APP_API_URL;

function MySessions({ userId, onLogout, isVerified }) {


    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);


    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(true); // to track check status

    const handleSearch = (result) => {
        setSearchResults(result);
    };


    const [activePage, setActivePage] = useState(isVerified ? 'my-posts' : 'my-requests'); // Default active page


    const renderContent = () => {
        switch (activePage) {
            case "my-posts":
                return <MyPosts userId={userId} searchResults={searchResults} onLogout={onLogout} />;
            case "my-bookings":
                return <MyBookings userId={userId} searchResults={searchResults} onLogout={onLogout} />;
            case "my-requests":
                return <MyRequests userId={userId} searchResults={searchResults} onLogout={onLogout} />;
            case "accepted":
                return <AcceptedRequests userId={userId} searchResults={searchResults} onLogout={onLogout} />;
            case "pay":
                return <PaymentDetails userId={userId} searchResults={searchResults} onLogout={onLogout} />;
            default:
                return <Typography variant="h4" color="#ecf0f1">Welcome</Typography>;
        }
    };

    return (
        <div>
            {/* Navigation Bar */}
            <Header1 userId={userId} page_name={activePage} onSearch={handleSearch} onLogout={onLogout} />
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box>
                    <Platform />
                </Box>
                <Box>
                    <Typography
                        variant="h3"
                        component="h1"
                        align="center"

                        fontSize={{ xs: '1rem', sm: '2.5rem', md: '3rem' }}
                        sx={{
                            backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
                            mt: 10,
                            letterSpacing: 10,
                            WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
                            color: 'transparent',  // Makes the text itself transparent to show the gradient
                            // fontWeight: 'bold',  // Optional: you can make the text bold
                        }}
                        gutterBottom
                    >
                        My Sessions
                    </Typography>

                    {/* Replaced AppBar with Box for Navbar */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },  // Switch flexDirection to column for small screens, row for larger screens
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'black',
                            padding: { xs: '0.5rem', sm: '1rem' },  // Smaller padding for small screens, larger padding for larger screens
                            width: '100%',
                            // mt: { xs: 10, sm: 10 },  // Adjust margin-top based on screen size (smaller on small screens)
                        }}
                    >

                        <Grid container spacing={2} justifyContent="center" sx={{ flexDirection: { xs: 'column', sm: 'row' }, textAlign: 'center' }}>

                            {isVerified ? (
                                <>
                                    <Grid item>
                                        <Button
                                            onClick={() => setActivePage("my-posts")}
                                            sx={{
                                                color: activePage === "my-posts" ? "#1E90FF" : "#ecf0f1",
                                                textTransform: "none",
                                                letterSpacing: 3,
                                                fontSize: { xs: '0.9rem', sm: '1rem' }, // Responsive font size
                                                width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto width on larger screens
                                                "&:hover": {
                                                    backgroundColor: "#1111",
                                                },
                                                padding: { xs: '0.5rem', sm: '1rem' }, // Adjust padding for smaller screens
                                            }}
                                        >
                                            Hosted
                                        </Button>
                                    </Grid>



                                </>
                            ) : (
                                <>
                                    <Grid item>
                                        <Button
                                            onClick={() => setActivePage("my-requests")}
                                            sx={{
                                                color: activePage === "my-requests" ? "#1E90FF" : "#ecf0f1",
                                                textTransform: "none",
                                                letterSpacing: 3,
                                                fontSize: { xs: '0.9rem', sm: '1rem' },
                                                width: { xs: '100%', sm: 'auto' },
                                                "&:hover": {
                                                    backgroundColor: "#1111",
                                                },
                                                padding: { xs: '0.5rem', sm: '1rem' },
                                            }}
                                        >
                                            Requested
                                        </Button>
                                    </Grid>

                                </>
                            )
                            }




                        </Grid>

                    </Box>

                    {/* Dynamic Content */}
                    <Box
                        sx={{
                            padding: { xs: "1rem", sm: "2rem" }, // Adjust padding for smaller and larger screens
                            backgroundColor: "black",
                            color: "white",
                            minHeight: "calc(100vh - 64px)", // Keeps the height full minus any fixed header
                            display: "flex",
                            flexDirection: "column", // Ensure content is stacked vertically on small screens
                            justifyContent: "center", // Centers content vertically
                            alignItems: "center", // Centers content horizontally
                            overflow: "hidden", // Prevents overflow on smaller screens
                        }}
                    >
                        {renderContent()}
                    </Box>
                </Box>
            </Box>

        </div>
    );
}

export default MySessions;
